
<div class="flex flex-row justify-between items-center gap-2 font-rubik">
  <quote-summary-dropdown v-if="quote" />
  <button v-else 
    class="get-quote-button border rounded-full flex items-center justify-center" 
    data-vue-init="lead-flow" data-props='{ "gtag": "get_quote"}'
  >
    <span>Get Quote</span>
  </button>
</div>
